import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from "../../App.js";


//Import AwesomeIcon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTiktok, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

//Import css
import './contactCompt.css';

//Import Assets
import LogoWebmedia from '../../assets/homeAssets/logoWebMedia.svg'
import ContactPhotoAgent from '../../assets/contactComptAssets/ContactPhotoAgent.svg'

//Import Component
import { BarraMenuDown } from '../home/barraMenuDown';
import { PanelMenuSlideDV } from '../developComponent/panelMenuSlideDV';



export function ContactCompt() {


    const {

    //Panel Menu Slide Dv
      openMenuSlideDv,
      setOpenMenuSlideDv,
      valorScreenDv,
      setValorScreenDv

    } = useContext(AppContext);





    return(

        <div className='container-all-contact-compt'>

            <BarraMenuDown />

            <PanelMenuSlideDV
            
                activeMenu='contacto'
            
            />

            {/* SECCION BOTON Y LOGO   */}
            <div className='box-btn-slide-logo-contact'>

                <div className='box-btn-menu-slide-contact'>

                    <button className="btn-menu-slide-contact" onClick={() => setOpenMenuSlideDv(!openMenuSlideDv)}>
                        
                        <span id='btn-slide-menu-open-contact' className="material-symbols-outlined">menu</span>
                        
                    </button>

                </div>


                <div className='box-logo-webmedia-contact'>

                    <img className='logo-webmedia-contact' src={LogoWebmedia} alt="Logo WebMedia"/>

                </div>

            </div>

            {/* SECCION BOX CONTACTO   */}
            <div className='box-contact-compt'>

                {/* Bloque Contacto desde Footer Component */}
                <div className="box-block-A-info-contact">


                    <div className="box-title-contact">

                        <h2 className="title-contact">CONTÁCTANOS</h2>
                        <a className="link-to-contact link-to-email" href="mailto:clientes@webmedia.com">clientes@webmedia.com</a>
                        <a className="link-to-contact link-to-telf" href="tel:+593987654321">Ec. 593 + 099 9909 735</a>

                    </div>

                    {/*  ____________________ */}

                    <div className="line-divisor-webmedia"></div>

                    {/* ____________________ */}

                    <div className="box-siguenos-icons">

                        <p className="text-siguenos">Síguenos</p>
                        
                        {/* BOX ICONOS REDES */}
                        <div className="box-icon-redes-contact">

                            <a className="icon-social-media icon-fb" href="https://www.facebook.com/monitronixEc/" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faFacebookF}/>
                            </a>

                            <a className="icon-social-media icon-tk" href="https://www.tiktok.com/@monitronixec" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faTiktok}/>
                            </a>

                            <a className="icon-social-media icon-Ins" href="https://www.instagram.com/monitronixec/" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faInstagram}/>
                            </a>

                            <a className="icon-social-media icon-Wts" href="https://wa.me/593967124133" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faWhatsapp}/>        
                            </a>

                        </div>

                    </div>

                </div>
                {/* Fin BLoque A */}

                {/* Bloque Contact Photo Contact Compt */}
                <div className="box-block-B-photo-contact-compt">

                    <img className='photoContactAgent' alt='Contacto WebMedia' src={ContactPhotoAgent}/>

                </div>

            </div>

        </div>


    );

}